export const createSlugFromUrl = (url) => {
  const idWithSlug = url.substring(url.lastIndexOf('/') + 1)
  const articleNameSlug = idWithSlug.substring(idWithSlug.indexOf('-', 0) + 1).toLowerCase()

  return articleNameSlug
}
